export default __webpack_public_path__ + "static/media/alimetacao.1bcaf704.png";